import React from 'react';

/**
 * ProgressBar
 * ------------------------------------------------------------------
 * Simple labeled progress track, e.g. XP progress (4550 / 5000).
 * Percent is derived from value/max and clamped to [0, 100].
 * Tone is applied via CSS classes so pages can override with tokens.
 *
 * @param {number} value
 * @param {number} max
 * @param {string} label - optional text under/beside the bar (e.g. "5000")
 * @param {'purple'|'blue'|'green'} tone
 */
const ProgressBar = ({ value = 0, max = 100, label, tone = 'purple', className = '' }) => {
  const percent = Math.min(100, Math.max(0, (value / max) * 100 || 0));

  return (
    <div className={`progress-bar progress-bar--${tone} ${className}`}>
      <div
        className="progress-bar__track"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div
          className="progress-bar__fill"
          style={{ width: `${percent}%` }}
        />
      </div>
      {label && <span className="progress-bar__label">{label}</span>}
    </div>
  );
};

export default ProgressBar;
